<template>
  <div v-show="isShow.isPRShow" class="makebox">
    <div class="mbox">
      <div class="mtu mtSlideIn">
        <img src="" id="mypic" />
        <div class="mtip">长按保存图片，晒晒你的“粮”月计划</div>
      </div>

    </div>
    <div class="btnbox">
      <div class="rbtn rechooce" @click="goBack"></div>
      <div class="rbtn lingjuan" @click="lj"></div>
    </div>

    <div class="mybox">
      <canvas id="mycanvas" width="750" height="1206" />
      <img src="./2.jpg" id="bg1" />
      <img src="./1.jpg" id="bg2" />
      <img src="./ewm.png" id="ewm" />
      <img src="./ff1.png" id="ff1" alt="">
      <img src="./ff2.png" id="ff2" alt="">
      <img src="./ff3.png" id="ff3" alt="">
      <img src="./ff4.png" id="ff4" alt="">
      <img src="./ff5.png" id="ff5" alt="">
      <img src="./ff6.png" id="ff6" alt="">
      <img src="./fm2.png" id="fm2" alt="">
      <img src="./fm3.png" id="fm3" alt="">
      <img src="./fm4.png" id="fm4" alt="">
      <img src="./fm5.png" id="fm5" alt="">
      <img src="./mm1.png" id="mm1" alt="">
      <img src="./mm2.png" id="mm2" alt="">
      <img src="./mm3.png" id="mm3" alt="">
      <img src="./mm4.png" id="mm4" alt="">
      <img src="./mm5.png" id="mm5" alt="">
      <img src="./mf1.png" id="mf1" alt="">
      <img src="./mf2.png" id="mf2" alt="">
      <img src="./mf3.png" id="mf3" alt="">
      <img src="./mf4.png" id="mf4" alt="">
      <img src="./mf5.png" id="mf5" alt="">
      <img src="./mf6.png" id="mf6" alt="">
    </div>
    <!--<button class="btn" @click="showNext">点击</button>-->
  </div>
</template>

<script>
import { sizeData } from './size.js'

export default {
  name: 'PageThree',
  props: {
    isShow: {
      type: Object
    },
    msubdata:{
      type: Object
    },
    subselectsex:{
      type:String
    }
  },
  data(){
    return{
      mySizeData: sizeData
    }
  },
  methods: {
    showNext () {
      this.isShow.isKVShow = true
      this.isShow.isPRShow = false
    },
    lj(){
      window.location.href='https://pro.m.jd.com/mall/active/3qPR2zoxseoSsr43akdZLQwpRduX/index.html'
    },
    goBack () {
      this.$emit('backAgain')
    },
    makehaibao(name,city){
      console.log(this.subselectsex)

      let cans=document.getElementById('mycanvas')
      let ctx=cans.getContext('2d')
      let img1=''
      let titleDraw = ''
      let position = {}

      //大背景
      if(this.subselectsex=='0'){
        //男
        img1=document.getElementById("bg1")
        const myId = this.msubdata.zhufu1
        titleDraw = document.getElementById(myId)
        position = this.mySizeData[this.msubdata.zhufu1]
        ctx.drawImage(img1,0,0,750,1206)
        let pX = 0
        if (position.w < 300) {
          pX = 375 + 64
        } else if (position.w > 300 && position.w < 320) {
          pX = 375 + 20
        } else {
          pX = 375
        }

        ctx.drawImage(titleDraw, pX, 110, position.w, position.h)
      }else{
        //女
        img1=document.getElementById("bg2")
        const myId = this.msubdata.zhufu2
        titleDraw = document.getElementById(myId)
        position = this.mySizeData[this.msubdata.zhufu2]
        ctx.drawImage(img1,0,0,750,1206)
        let pX = 0

        if (position.w < 300) {
          pX = 366 + 64
        } else if (position.w > 300 && position.w < 320) {
          pX = 366 + 40
        } else {
          pX = 366
        }

        ctx.drawImage(titleDraw, pX, 220, position.w, position.h)
      }

      //二维码
      let ewm=document.getElementById("ewm")

      ctx.drawImage(ewm,630,1085,100,100)

      //文字
      if(this.subselectsex=='0'){
        //男
        ctx.font = '28px 微软雅黑';  //只有设置字体样式(微软雅黑)后，大小才会生效。
        ctx.fillStyle = '#fcf7bb';

        ctx.textAlign = 'right'
        ctx.textBaseline = 'top'

        let txt1=name+'在'+city+'过中秋'
        ctx.fillText( txt1, 715, 44 )
      }else{
        //女
        ctx.font = '28px 微软雅黑';  //只有设置字体样式(微软雅黑)后，大小才会生效。
        ctx.fillStyle = '#fe7823';

        ctx.textAlign = 'right'
        ctx.textBaseline = 'top'


        let txt1=name+'在'+city+'过中秋'
        ctx.fillText( txt1, 722, 164 )
      }

      var image = document.getElementById('mypic');
      setTimeout(()=>{
	      image.src = cans.toDataURL("image/jpeg");
      },200)
    }
  },
  watch:{
    msubdata(){
      console.log(this.msubdata)
      let name=this.msubdata.name
      let city=this.msubdata.city
      // let zhufu1=this.msubdata.zhufu1

      this.makehaibao(name,city)
    }
  }
}
</script>

<style lang="less" scoped>
  .makebox{
    background-image: url(../page-two/bg.jpg);
    background-size:100% 100%;
    width: 100%;
    height: 100%;

    .mtu{
      width: 80%;
      position: absolute;
      left: 10%;
      top: 2vh;

      img{
        border: 2px solid #fff;
        width: 100%;
      }

      .mtip{
        text-align: center;
        padding-top: .625rem /* 10/16 */;
      }

    }

    .rbtn{
      width: 15.5625/2rem /* 249/16 */;
      height:6.0625/2rem /* 97/16 */;
      background-size: 100% 100%;
    }

    .btnbox{
      width: 80%;
      position: absolute;
      left: 10%;
      bottom: 2%;
    }

    .rechooce{
      background-image: url(./btn1.png);
      float: left;
    }

    .lingjuan{
      background-image: url(./btn2.png);
      float:right;
    }

    .mybox{
      display: none;
    }
  }

  .mtSlideIn {
    animation: mtSlideIn 1s linear;
  }

  @keyframes mtSlideIn {
    0%, 20% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>
